import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { OrderDetails } from '@interfaces/orders/1.0';
import { Observable } from 'rxjs';
import { BadgeType } from '@constants/badge/1.0';
import { UtilitiesService } from '@services/utilities/1.0/utilities.service';
import { NgIf, NgFor, NgClass, NgTemplateOutlet, DecimalPipe } from '@angular/common';
import { BadgeComponent } from '@components/badge/1.0/badge.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-order-pdf',
  templateUrl: './order-pdf.component.html',
  styleUrls: ['./order-pdf.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, BadgeComponent, NgTemplateOutlet, TranslateModule, DecimalPipe],
})
export class OrderPdfComponent {
  @ViewChild('pdfContent') pdfContent!: ElementRef;
  orderDetails: OrderDetails;
  currency: string;
  badgeType = BadgeType; // expose enum to template

  constructor(
    private cdr: ChangeDetectorRef,
    private utilitiesService: UtilitiesService,
  ) {}

  generatePdf(orderDetails: OrderDetails, currency: string): Observable<void> {
    return new Observable<void>((observer) => {
      this.orderDetails = orderDetails;
      this.currency = currency;

      this.cdr.detectChanges();

      const element = this.pdfContent.nativeElement;

      this.utilitiesService
        .generatePdf(element, 2, 0.7)
        .then((pdfBlob) => {
          const pdfUrl = URL.createObjectURL(pdfBlob);
          window.open(pdfUrl);

          observer.next();
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }

  /**
   * Translate device type enum with fallback to original string
   */
  translateDeviceType(deviceType: string): string {
    return this.utilitiesService.translateDeviceType(deviceType);
  }

  /**
   * Translate ordering channel enum with fallback to original string
   */
  translateOrderingChannel(orderingChannel: string): string {
    return this.utilitiesService.translateOrderingChannel(orderingChannel);
  }
}
